"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadOrderEvaluateList = downloadOrderEvaluateList;
exports.getAggregate = getAggregate;
exports.getOrderEvaluatelndex = getOrderEvaluatelndex;
exports.updateOrderEvaluatelndex = updateOrderEvaluatelndex;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
function getOrderEvaluatelndex(query) {
  return (0, _requestAuth.default)({
    url: '/xyOrderComment/page',
    method: 'get',
    params: query
  });
}
function updateOrderEvaluatelndex(data) {
  return (0, _requestAuth.default)({
    url: '/xyOrderComment/update',
    method: 'post',
    data: data
  });
}
function downloadOrderEvaluateList(data) {
  return (0, _requestAuth.default)({
    url: '/xyOrderComment/downloadList',
    method: 'post',
    data: data
  });
}
function getAggregate(data) {
  return (0, _requestAuth.default)({
    url: '/xyOrderComment/getAggregate',
    method: 'post',
    data: data
  });
}